<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h2 class="page-title"><i class="fas fa-bullhorn"></i> Campaings</h2>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <p>Campaings content</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "Campaigns_bSales",
    components: {},
    data() {
        return {};
    },
    created() {},
    methods: {},
    computed: {
        ...mapGetters({
            get_acl_url: "core/get_acl_url",
        }),
    },
};
</script>
<style lang="scss" scoped>
</style>
